import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbMergeApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbMerge';
    }

    /**
     * 分页获取数据
     * @param params 
     * @returns 
     */
     public getdbMergePage(current: number, size: number = 10, devProd: string = '',DbId: number = 0, Summary) {
        return this.send({ current, size, devProd, DbId,Summary }, "getEntitiesPage", Methods.GET)
    }
}